export enum BASE_TYPES {
    SURVEY = 'survey',
    POLL = 'poll'
}

export enum BASE_TYPE_IDS {
    SURVEY = 1,
    POLL = 2
}